module.exports = __webpack_public_path__ + "img/PRJ WEB.a5f4a211.jpg";